import React, { useContext } from 'react'
import styled from 'styled-components'
import media from 'css-in-js-media'

import SwiperCore, { Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import CaretLeft from '../svg/caret-left.svg'
import CaretRight from '../svg/caret-right.svg'

// install Swiper components
SwiperCore.use([Pagination, Navigation])

// Import Swiper styles
import 'swiper/swiper.scss'
import Container from './Container'
import { Variables } from '../styles/Variables'

const AmenitiesSwiper = styled(Swiper)``

const AmenitiesSliderWrap = styled.div`    
    ${Container} {
        display: flex;
        align-items: center;
    }
`

const SliderPagination = styled.div`
    position: absolute;
    z-index: 10;
    top: 40px;
    left: 60px;
    font-size: 18px;
    line-height: 22px;
    color: ${Variables.color.white};

    ${media('<desktop')} {
        left: 20px;
    }
`

const Arrow = styled.div`
    position: absolute;
    bottom: 40px;    
    z-index: 10;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    ${media('<desktop')} {
        bottom: 20px;
    }

    svg {
        transition: 0.1s transform ease-out;
        will-change: transform;
    }
    svg path {
        stroke: #ffffff;
    }
`

const ArrowLeft = styled(Arrow)`
    left: 60px;

    ${media('<desktop')} {
        left: 20px;
    }

    &:active {
        svg {
            transform: translateX(-3px);
        }
    }
`

const ArrowRight = styled(Arrow)`
    right: 60px;

    ${media('<desktop')} {
        right: 20px;
    }

    &:active {
        svg {
            transform: translateX(3px);
        }
    }
`

const AmenitiesSlider = ({ children, onSlideChange, onSetAmenitiesSlider }) => {
    
    return (
        <>
            <AmenitiesSliderWrap>
                <AmenitiesSwiper
                    navigation={{
                        prevEl: '.AmenitiesPrev',
                        nextEl: '.AmenitiesNext',
                    }}
                    speed={1500}
                    slidesPerView="1"
                    loop={false}
                    pagination={{
                        el: '.AmenitiesPagination',
                        type: 'fraction',
                    }}
                    onSlideChange={onSlideChange}
                    onSwiper={(instance) => {
                        onSetAmenitiesSlider(instance)
                    }}
                    
                >
                    {children.length > 0 ? (
                        children.map((slide, index) => {
                            return <SwiperSlide key={index}>{slide}</SwiperSlide>
                        })
                    ) : (
                        <SwiperSlide>{children}</SwiperSlide>
                    )}
                    <ArrowLeft className="AmenitiesPrev">
                        <CaretLeft />
                    </ArrowLeft>
                    <ArrowRight className="AmenitiesNext">
                        <CaretRight />
                    </ArrowRight>
                    <SliderPagination className="AmenitiesPagination swiper-pagination" />
                </AmenitiesSwiper>                
            </AmenitiesSliderWrap>
        </>
    )
}

export default AmenitiesSlider
